import { createModel } from "nyax";
import { DataQueue } from "src/models/dataQueue";
import { createItemsEntityModel } from "src/store/itemsEntity";

export const DataQueueEntityModel = createModel(
  class extends createItemsEntityModel<DataQueue>((item) => item.id) {
    public selectors() {
      return {
        ...super.selectors(),
      };
    }
  }
);
